import React, { useEffect, useState } from "react";
// import Header from "../../components/header/Header";
// import Navbar from "../../components/navbar/Navbar";
// import Footer from "../../components/footer/Footer";
import { Accordion } from "flowbite-react";
import { getFetcher } from "../../../api/fetchers";
import { endpoints } from "../../../api/endpoints";

interface IContract {
  key: string;
  value: string;
}

const AllContracts: React.FC = () => {
  const [contracts, setContracts] = useState<IContract[]>([]);

  const [kvkk, setKvkk] = useState<{ value: string; key: string }>({ value: '', key: '' });
  const [privacyAndSecurityPolicy, setPrivacyAndSecurityPolicy] = useState<{ value: string; key: string }>({ value: '', key: '' });
  const [distanceSellingContract, setDistanceSellingContract] = useState<{ value: string; key: string }>({ value: '', key: '' });

  // FETCH ALL CONTRACTS
  useEffect(() => {
    const fetchAllContracts = async () => {
      try {
        const response = await getFetcher(endpoints.auth.getContracts);

        if (response.result) {
          setContracts(response.contracts);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchAllContracts();
  }, []);

  const contractTitle = (key: string) => {
    switch (key) {
       //case 'kvkk-supplier':
        // return 'KVKK TEDARİKÇİ';
      case 'kvkk':
        return 'KVKK';
      case 'privacy_and_security_policy':
        return 'GİZLİLİK VE GÜVENLİK POLİTİKASI';
       case 'distance_selling_contract':
         return 'MESAFELİ SATIŞ SÖZLEŞMESİ';
      default:
        return '';
    }
  };

  // CONTRACT MAPPING
  useEffect(() => {
    contracts.forEach((contract) => {
      switch (contract.key) {
        // case 'kvkk-supplier':
          // setKvkkSupplier({ value: contract.value, key: contract.key });
         //  break;
        case 'kvkk':
          setKvkk({ value: contract.value, key: contract.key });
          break;
        case 'privacy_and_security_policy':
          setPrivacyAndSecurityPolicy({ value: contract.value, key: contract.key });
          break;
         case 'distance_selling_contract':
           setDistanceSellingContract({ value: contract.value, key: contract.key });
           break;
        default:
          break;
      }
    });
  }, [contracts]);

  const contractPanels = [
     //kvkkSupplier,
    kvkk,
    privacyAndSecurityPolicy,
     distanceSellingContract,
  ]
    .filter((contract) => contract.value)
    .map((contract) => (
      <Accordion.Panel key={contract.key}>
        <Accordion.Title>{contractTitle(contract.key)}</Accordion.Title>
        <Accordion.Content>
          <div
            className="mb-2 text-gray-500 dark:text-gray-400"
            dangerouslySetInnerHTML={{ __html: contract.value }}
          />
        </Accordion.Content>
      </Accordion.Panel>
    ));

  return (
    <div className="min-h-screen flex flex-col justify-between ">
      {/* <Header />
      <Navbar /> */}
      <div className="p-4 w-full sm:w-6/12 mx-auto my-8 min-h-[500px] bg-gray-50 rounded-xl shadow-xl">
        <Accordion>{contractPanels}</Accordion>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default AllContracts;
